import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Consultor } from "../models/consultores.model";

@Injectable({
  providedIn: "root",
})
export class ConsultoresService {
  constructor(private http: HttpClient) {}
  private consultores$ = new BehaviorSubject<Consultor[]>(null);
  public cidadesConsultores$ = new BehaviorSubject<any[]>([]); // Observable para cidades

  public getAll(): Observable<Consultor[]> {
    return this.http.get<Consultor[]>(environment.rotaConsultores).pipe(
      map((consultor) =>
        consultor.map((consultor) => new Consultor().deserialize(consultor))
      ),
      catchError(() => throwError("Consultor não encontrado."))
    );
  }
  
  public getAll$() {
    this.http
      .get<Consultor[]>(environment.rotaConsultores)
      .pipe(take(1))
      .subscribe((consultores) => {
        consultores.sort((a, b) => +b.ativa - +a.ativa);
        this.consultores$.next(consultores);
      });
    this.getCidadesConsultores();
  }

  getCidadesConsultores(): void {
    const cidadesTemp: Set<string> = new Set();

    this.consultores$.subscribe((consultores) => {
      if (consultores) {
        // Verifica se existem consultores
        consultores.forEach((empresa) => {
          if (empresa.cidade) {
            cidadesTemp.add(empresa.cidade); // Adiciona cidades ao Set
          }
        });

        // Converte o Set em um array e adiciona "Todas"
        const cidadesConsultores = Array.from(cidadesTemp).map((cidade) => ({
          nomeCidade: cidade,
        }));
        cidadesConsultores.sort((a, b) =>
          a.nomeCidade.localeCompare(b.nomeCidade)
        );
        cidadesConsultores.unshift({ nomeCidade: "Todas" });

        // Atualiza o BehaviorSubject com as cidades filtradas
        this.cidadesConsultores$.next(cidadesConsultores);
      }
    });
  }
  public escutarMudancasConsultor(): Observable<Consultor[]> {
    return this.consultores$.asObservable();
  }

  public atualizarConsultores(consultores: Consultor[]) {
    return this.consultores$.next(consultores);
  }

  private updateConsultorInState(updatedConsultor: Consultor) {
    this.consultores$.pipe(take(1)).subscribe((consultores) => {
      // Substitui a guia atualizada na lista do BehaviorSubject
      const updatedConsultors = consultores.map((guia) =>
        guia._id === updatedConsultor._id ? updatedConsultor : guia
      );
      // Atualiza o BehaviorSubject com a nova lista
      this.consultores$.next(updatedConsultors);
    });
  }

  private adicionarConsultor(consultor: Consultor) {
    const consultoresAtuais = this.consultores$.value;
    this.consultores$.next([consultor, ...consultoresAtuais]);
  }

  public edit(updatedConsultor: Consultor) {
    return this.http
      .patch(
        `${environment.rotaConsultores}/${updatedConsultor._id}`,
        updatedConsultor
      )
      .pipe(
        map(() => {
          // Atualiza a lista localmente após sucesso na atualização do servidor
          this.updateConsultorInState(updatedConsultor);
        }),
        catchError((error) => throwError("Erro ao atualizar consultor: " + error))
      );
  }

  public create(consultor: Consultor): Observable<any> {
    return this.http.post(environment.rotaConsultores, consultor).pipe(
      map((novoConsultor: Consultor) => {
        this.adicionarConsultor(novoConsultor);
      }),
      catchError((error) => throwError("Erro ao criar empresa " + error))
    );
  }

  public delete(consultor: Consultor): Observable<any> {
    return this.http.delete(environment.rotaConsultores + "/" + consultor._id);
  }
}
